<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('identity.update_title') }}</span>
            <span v-else>{{ $t('identity.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('identity.name') }}</label>
          <b-form-input type="text" :placeholder="$t('identity.name_placeholder')"
            :class="{ 'is-invalid' : fErr('name') }"
            v-model="entity.name"/>
        </b-form-group>
          <b-form-group :invalid-feedback="fErr('logo')">
            <label>{{ $t('identity.logo') }}</label>
            <b-form-file :browse-text="$t('identity.select_file')" accept="image/*" @change="onLogoChange">
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input type="file" class="custom-file-input">
                  <label class="custom-file-label">Select File</label>
                </div>
              </div>
            </b-form-file>
            <div v-if="logoPreview" class="identity-img-preview">
              <img :src="logoPreview">
            </div>
            <img v-else-if="id && entity.has_logo" class="identity-img-preview"
              :src="`${baseUrl}identities/${id}/logo?ts=${entity.has_logo}&token=${token}`" >
          </b-form-group>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Identities' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import { mapState } from 'vuex';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      logoPreview: null,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
          logo: null,
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
  },
  methods: {
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? Services.identities.editData : Services.identities.createData;
      action(this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.identity : { ...this.entity, ...data.data.identity };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    onLogoChange(e) {
      const file = e.target.files[0];
      this.entity.logo = file;
      this.logoPreview = URL.createObjectURL(file);
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? Services.identities.update : Services.identities.create;
      const formData = new FormData();
      formData.append('logo', this.entity.logo);
      formData.append('name', this.entity.name);
      if (this.entity.id) {
        formData.append('id', this.entity.id);
        formData.append('_method', 'PUT');
      }
      action(formData).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          this.$router.push({ name: 'Identities', params: { id: data.data.id } });
        }
        this.logoPreview = null;
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped>
  .identity-img-preview img {
    max-width: 128px;
    margin-top: 0.5rem;
  }
</style>
